export interface Formation {
    slug: string
    title: string
    level: string
    duration: string
    description: string
    fullDescription?: string
    image: string
    imageAlt?: string
    themeColor?: string
    iconName?: string
    isRncp?: boolean
    rncpLink?: string
    infos?: any // Temporary until specialized
    stats?: { label: string, value: string }[]
    tags?: string[]
    videoUrl?: string
    // SEO fields
    metaTitle?: string
    metaDescription?: string
    keywords?: string
    ogImage?: string
    // Content
    program?: any
}

export const useFormations = () => {
    const config = useRuntimeConfig()
    const apiBase = config.public.apiBase

    const getAllFormations = async (): Promise<Formation[]> => {
        try {
            const data = await $fetch<Formation[]>(`${apiBase}/oxoweb/formations`)
            return (data || []).map(f => ({
                ...f,
                isRncp: f.isRncp || !!f.rncpLink || !!(f.description && (f.description.includes('Certifiant') || f.description.includes('RNCP')))
            }))
        } catch (error) {
            console.error('Error fetching formations:', error)
            return []
        }
    }

    const getFormationBySlug = async (slug: string): Promise<Formation | null> => {
        try {
            const formation = await $fetch<Formation>(`${apiBase}/oxoweb/formations/${slug}`)

            if (!formation) return null

            const infos = formation.infos || []

            // Helper to parse JSON content or fallback to string
            const parseList = (item: any) => {
                if (!item || !item.content) return []
                try {
                    const parsed = JSON.parse(item.content)
                    return Array.isArray(parsed) ? parsed : [item.content]
                } catch {
                    return [item.content]
                }
            }

            const adaptedInfos = {
                prerequisites: parseList(infos.find((i: any) => i.title === 'PREREQUISITES')),
                admission: parseList(infos.find((i: any) => i.title === 'ADMISSION')),
                opportunities: parseList(infos.find((i: any) => i.title === 'OPPORTUNITIES')),
                environments: parseList(infos.find((i: any) => i.title === 'ENVIRONMENTS'))
            }

            return {
                ...formation,
                isRncp: formation.isRncp || !!formation.rncpLink || !!(formation.description && (formation.description.includes('Certifiant') || formation.description.includes('RNCP'))),
                infos: adaptedInfos,
                stats: formation.stats || (formation as any).Stats || []
            }
        } catch (error) {
            console.error(`Error fetching formation ${slug}:`, error)
            return null
        }
    }

    return {
        getAllFormations,
        getFormationBySlug
    }
}
